import { useContext } from 'react';
import useCURD_Queries from '../queryGenerals/useCURD_Queries';
import { GlobalContext } from '../../../App';
import { updateOrAddItem, useAddData, useGetDataByName, useUpdateData } from '../../dataLocal/indexedDBHooks';
import { DataContext } from '../../../new_version/pages/pagesMains/GravesManagers/Graves';

const getUserIP = async () => {
  try {
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    return data.ip;
  } catch (error) {
    console.error('שגיאה בקבלת כתובת IP:', error);
    return null;
  }
};

const usePurchaseQueries = () => {
  const { setDataPurchases, userId, db } = useContext(GlobalContext);
  const context = useContext(DataContext);
  const { AllDataEntities, NextAutoIncrementEntity, addOrUpdateDataEntity2, removeEntity } = useCURD_Queries();

  const addData = useAddData(db, 'myStore');
  const updateData = useUpdateData(db, 'myStore');
  const getDataByName = useGetDataByName(db, 'myStore');

  const AllDataPurchases = async () => {
    try {
      let query = `api/purchases/getPurchases`;
      let url = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PORT}/${query}`;
      let nameEntity = 'dataPurchases';

      const data = await AllDataEntities(url); // המתנה לתוצאה

      setDataPurchases(data?.resData || []);
      if (db) {
        getDataByName(nameEntity)
          .then((existingData) => {
            if (existingData.length > 0) {
              // אם הנתונים קיימים, עדכן אותם
              updateData({ id: 8, name: nameEntity, value: data?.resData || [] })
                .then(() => getDataByName(nameEntity))
                .then((data) => {
                  // console.log('Updated Data:', data);
                })
                .catch((error) => console.error('Error updating data:', error));
            } else {
              // אם הנתונים לא קיימים, הוסף אותם
              addData({ id: 8, name: nameEntity, value: data?.resData || [] })
                .then(() => getDataByName(nameEntity))
                .then((data) => {
                  // console.log('Added Data:', data);
                })
                .catch((error) => console.error('Error adding data:', error));
            }
          })
          .catch((error) => console.error('Error getting data by name:', error));
      }
    } catch (error) {
      console.error('שגיאה בטעינת נתונים: ', error);
    }
  };

  const AllDataPurchasesOld = async () => {
    try {
      let query = `api/purchases/getPurchasesOld`;
      let url = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PORT}/${query}`;
      let nameEntity = 'dataPurchasesOld';

      const data = await AllDataEntities(url); // המתנה לתוצאה

      setDataPurchases(data?.resData || []);
      if (db) {
        getDataByName(nameEntity)
          .then((existingData) => {
            if (existingData.length > 0) {
              // אם הנתונים קיימים, עדכן אותם
              updateData({ id: 14, name: nameEntity, value: data?.resData || [] })
                .then(() => getDataByName(nameEntity))
                .then((data) => {
                  // console.log('Updated Data:', data);
                })
                .catch((error) => console.error('Error updating data:', error));
            } else {
              // אם הנתונים לא קיימים, הוסף אותם
              addData({ id: 14, name: nameEntity, value: data?.resData || [] })
                .then(() => getDataByName(nameEntity))
                .then((data) => {
                  // console.log('Added Data:', data);
                })
                .catch((error) => console.error('Error adding data:', error));
            }
          })
          .catch((error) => console.error('Error getting data by name:', error));
      }
    } catch (error) {
      console.error('שגיאה בטעינת נתונים: ', error);
    }
  };

  const addOrUpdateDataPurchase = async (data, unicId) => {
    let create = `api/purchases/addPurchase`;
    let update = `api/purchases/updatePurchase`;
    let url = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PORT}/${data?.unicId ? update : create}`;

    const next = await NextPurchaseId()
    let purchase = { ...data,
      serialPurchaseId: next?.resData?.serialPurchaseId
     };

    let ip = '';
    // דוגמה לשימוש בפונקציה
    await getUserIP().then((myIp) => {
      ip = myIp;
    });

    // נתונים מינימליים לשליחה לשרת
    const payload = {
      userId,
      recordId: data?.unicId,
      ipAddress: ip,
      tableName: 'purchases',
      actionType: data?.unicId ? 'UPDATE' : 'INSERT',
      oldValue: null,
      newValue: data
    };

    if (!purchase?.unicId) {
      data = {
        ...data,
        unicId: unicId
      };
      purchase = {
        ...purchase,
        unicId: unicId
      };
    }

    delete purchase?.cemeteryId;
    delete purchase?.blockId;
    delete purchase?.plotId;
    delete purchase?.lineId;
    delete purchase?.areaGraveId;

    const tempGrave = context?.contextGraves?.find((e) => e?.unicId === data?.graveId)
    if (tempGrave) {
      tempGrave.graveStatus = tempGrave?.graveStatus === 1 ? 2 : tempGrave?.graveStatus;
    }
    
    const tempCustomer = context?.contextCustomers?.find((e) => e?.unicId === data?.clientId);
    if (tempCustomer) {
      tempCustomer.statusCustomer = tempCustomer?.statusCustomer === 1 ? 2 : tempCustomer?.statusCustomer;
    }

    const tempPurchase = {
      ...data,
      serialPurchaseId: next?.resData?.serialPurchaseId,
      cemeteryNameHe: tempGrave?.cemeteryNameHe,
      blockNameHe: tempGrave?.blockNameHe,
      plotNameHe: tempGrave?.plotNameHe,
      lineNameHe: tempGrave?.lineNameHe,
      areaGraveNameHe: tempGrave?.areaGraveNameHe,
      graveNameHe: tempGrave?.graveNameHe,
      cemeteryNameEn: tempGrave?.cemeteryNameEn,
      blockNameEn: tempGrave?.blockNameEn,
      plotNameEn: tempGrave?.plotNameEn,
      lineNameEn: tempGrave?.lineNameEn,
      areaGraveNameEn: tempGrave?.areaGraveNameEn,
      graveNameEn: tempGrave?.graveNameEn,
      clientFullNameHe: `${tempCustomer?.firstName} ${tempCustomer?.lastName}`,
      graveStatus: 2,
      ifCertificate: 0,
      isFuneralPayments: data?.isFuneralPayments || 1
    };

    console.log(1, 'tempPurchase: ', tempPurchase);
    console.log(2, 'payload: ', payload);
    console.log(3, 'tempCustomer: ', tempCustomer);
    console.log(4, 'tempGrave: ', tempGrave);
    

    console.log(5, next);
    
    try {
      let res = await addOrUpdateDataEntity2(purchase, payload, url);
      if (res) {
        await updateOrAddItem(db, 'myStore', tempPurchase, 'dataPurchases', 8);
        await updateOrAddItem(db, 'myStore', tempGrave, 'dataGraves', 6);
        await updateOrAddItem(db, 'myStore', tempCustomer, 'dataCustomers', 7);
    
    
        context?.setContextPurchases((prev) => {
          // בדיקה אם הערך קיים בסטייט
          const existingIndex = prev.findIndex((item) => item.unicId === tempPurchase.unicId);
    
          if (existingIndex !== -1) {
            // אם הערך קיים, מעדכן אותו
            const updatedState = [...prev];
            updatedState[existingIndex] = { ...updatedState[existingIndex], ...tempPurchase };
    
            return updatedState;
          } else {
            // אם הערך לא קיים, מוסיף אותו
            return [...prev, { ...tempPurchase }];
          }
        });
    
        context?.setContextGraves((prev) => {
          // בדיקה אם הערך קיים בסטייט
          const existingIndex = prev.findIndex((item) => item.unicId === tempGrave.unicId);
    
          if (existingIndex !== -1) {
            // אם הערך קיים, מעדכן אותו
            const updatedState = [...prev];
            updatedState[existingIndex] = { ...updatedState[existingIndex], ...tempGrave };
    
            return updatedState;
          } else {
            // אם הערך לא קיים, מוסיף אותו
            return [...prev, { ...tempGrave }];
          }
        });
    
        context?.setContextCustomers((prev) => {
          // בדיקה אם הערך קיים בסטייט
          const existingIndex = prev.findIndex((item) => item.unicId === tempCustomer.unicId);
    
          if (existingIndex !== -1) {
            // אם הערך קיים, מעדכן אותו
            const updatedState = [...prev];
            updatedState[existingIndex] = { ...updatedState[existingIndex], ...tempCustomer };
    
            return updatedState;
          } else {
            // אם הערך לא קיים, מוסיף אותו
            return [...prev, { ...tempCustomer }];
          }
        });
        
        AllDataPurchases();

        console.log('התוצאה הצליחה...');
        return res;
      }
    } catch (error) {
      console.error('שגיאה בתהליך העדכון/הוספה:', error);
    }
  };

  const duplicateAndUpdatePurchase = async (data, unicId) => {
    let update = `api/purchases/transferPurchase`;
    let url = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PORT}/${update}`;

    let ip = '';
    // דוגמה לשימוש בפונקציה
    await getUserIP().then((myIp) => {
      ip = myIp;
    });

    // נתונים מינימליים לשליחה לשרת
    const payload = {
      userId,
      recordId: data?.unicId,
      ipAddress: ip,
      tableName: 'purchases',
      actionType: 'UPDATE',
      oldValue: null,
      newValue: data
    };

    if (!data?.unicId) {
      data = {
        ...data,
        unicId: unicId
      };
    }

    console.log(234, data);

    try {
      let res = await addOrUpdateDataEntity2(data, payload, url);
      if (res) {
        // await updateOrAddItem(db, 'myStore', data, 'dataPurchases', 8 );
        console.log('התוצאה הצליחה...');
        return res;
      }
    } catch (error) {
      console.error('שגיאה בתהליך העדכון/הוספה:', error);
    }
  };

  const removePurchase = async (data) => {
    let query = `api/purchases/removePurchase`;
    let url = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PORT}/${query}`;
    // removeEntity(id, url)

    try {
      let res = await removeEntity(data, url);
      AllDataPurchases();
      if (res) {
        console.log('התוצאה הצליחה...');
        return res;
      } else {
        console.log(res);

        return false;
      }
    } catch (error) {
      console.error('שגיאה בתהליך העדכון/הוספה:', error);
      return false;
    }
  };

  // שימוש בפונקציה הגלובלית
  const NextPurchaseId = async () => {      
      try {
        let query = `api/purchases/getNextAutoIncrementPurchase`;
        let url = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PORT}/${query}`;
        
        const data = await NextAutoIncrementEntity(url); // המתנה לתוצאה
        return data
    } catch (error) {
      console.error('❌ שגיאה בקבלת ID הבא של רכישה:', error);
      return null;
    }
  };

  return {
    AllDataPurchases,
    AllDataPurchasesOld,
    addOrUpdateDataPurchase,
    duplicateAndUpdatePurchase,
    removePurchase
  };
};

export default usePurchaseQueries;
